import React from 'react';

import {AddNew} from './AddNew.jsx';
import {SortBox} from './SortBox.jsx';

var ActionBar = React.createClass({
  	onSortChange: function(value){
  			this.props.onSortChange(value);  // this will set the property when sortings will change.
  	},
    addNewDropdownShow: function(){
        this.props.addNewDropdownShow();
    },  
    sortBoxShow: function(){
        this.props.sortBoxShow();
    },
    setAddNewValue: function(value){
        this.props.setAddNewValue(value);
    },
    render: function () {
      return(
          <div className="filter-head clearfix">
              <AddNew addNew ={this.props.addNew}
                      addNewDropdownShow = {this.addNewDropdownShow}
                      addNewData = {this.props.addNewData}
                      setAddNewValue = {this.setAddNewValue}
                      addNewValue = {this.props.addNewValue} />
              <SortBox  onSortChange = {this.onSortChange}
                        sortBy = {this.props.sortBy}
                        sortBoxShow = {this.sortBoxShow}
                        sort = {this.props.sort} />
          </div>
        );
    } 
}); 
export {ActionBar};


/** WEBPACK FOOTER **
 ** ./html/components/ActionBar.jsx
 **/